import Header from "@/components/Header";
import SubmissionsContent from "@/components/SubmissionContent";

// import Sponsors from "@/components/Sponsors";

const TimeSchedule = () => {
  return (
    <>
      <Header />
      <SubmissionsContent />
    </>
  );
};

export default TimeSchedule;
